/* ==========================================================================
   Pahle Design – Verhalten (Warenkorb-Drawer, Menüs, Produktseite, Pop-up)
   Keine Abhängigkeiten. Wird mit defer geladen.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.PAHLE || {};
  var ROUTES = CFG.routes || {};
  var TEXT = CFG.text || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var root = (ROUTES.root || '/').replace(/\/?$/, '/');

  /* ---------- Hilfsfunktionen ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || CFG.moneyFormat || '{{amount_with_comma_separator}} €';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount_with_comma_separator') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2, '.', ',');
    }
    return format.replace(placeholder, value).replace(/<[^>]*>/g, '');
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || TEXT.error);
          err.data = data; throw err;
        }
        return data;
      });
    });
  }

  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'p-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  function isDesktop() { return window.matchMedia('(min-width: 990px)').matches; }

  // Bilder in versteckten Bereichen (Mega-Menü, Mobilmenü, Pop-up) erst beim Öffnen laden
  function loadDeferred(root) {
    $$('img[data-p-src], img[data-p-srcset]', root).forEach(function (img) {
      if (img.hasAttribute('data-p-srcset')) { img.setAttribute('srcset', img.getAttribute('data-p-srcset')); img.removeAttribute('data-p-srcset'); }
      if (img.hasAttribute('data-p-src')) { img.setAttribute('src', img.getAttribute('data-p-src')); img.removeAttribute('data-p-src'); }
    });
  }

  /* ---------- Drawer (Warenkorb, Mobilmenü) ---------- */
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    closeAllDrawers(el);
    loadDeferred(el);
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('p-lock');
    var panel = $('.p-drawer__panel', el);
    if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeDrawer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.p-drawer.is-open') && !$('.p-modal.is-open')) document.documentElement.classList.remove('p-lock');
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function closeAllDrawers(except) {
    $$('.p-drawer.is-open').forEach(function (d) { if (d !== except) closeDrawer(d); });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-p-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.getAttribute('data-p-drawer-open'))); return; }
    var closer = e.target.closest('[data-p-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.p-drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.p-drawer.is-open').forEach(closeDrawer);
    closeMegas();
    Exit.close();
  });

  /* ---------- Warenkorb ---------- */
  var Cart = {
    el: function () { return $('[data-p-cart]'); },
    sectionId: function () { var el = Cart.el(); return el ? el.getAttribute('data-section-id') : null; },
    open: function () {
      var el = Cart.el();
      if (!el) { window.location.href = ROUTES.cart || '/cart'; return; }
      openDrawer(el);
    },
    render: function (html) {
      var el = Cart.el();
      if (!el || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-p-cart-inner]', doc);
      var current = $('[data-p-cart-inner]', el);
      if (fresh && current) {
        var scroll = $('.p-cart__scroll', current);
        var top = scroll ? scroll.scrollTop : 0;
        current.replaceWith(fresh);
        initDeliveryPickers(fresh);
        var newScroll = $('.p-cart__scroll', fresh);
        if (newScroll) newScroll.scrollTop = top;
        Cart.updateCount(parseInt(fresh.getAttribute('data-count') || '0', 10), parseInt(fresh.getAttribute('data-total') || '0', 10));
      }
    },
    updateCount: function (count, total) {
      $$('[data-p-cart-count]').forEach(function (c) { c.textContent = count; c.hidden = !count; });
      document.dispatchEvent(new CustomEvent('pahle:cart:updated', { detail: { count: count, total: total } }));
    },
    refresh: function () {
      var id = Cart.sectionId();
      if (!id) return Promise.resolve();
      return fetch(root + '?sections=' + encodeURIComponent(id))
        .then(function (r) { return r.json(); })
        .then(function (data) { Cart.render(data[id]); })
        .catch(function () {});
    },
    add: function (items, stay) {
      var id = Cart.sectionId();
      var body = { items: items };
      if (id) { body.sections = id; body.sections_url = window.location.pathname; }
      return postJSON(ROUTES.cartAdd ? ROUTES.cartAdd + '.js' : '/cart/add.js', body).then(function (data) {
        if (id && data.sections && data.sections[id]) Cart.render(data.sections[id]);
        else return Cart.refresh();
      }).then(function () {
        if (!Cart.el()) { window.location.href = ROUTES.cart || '/cart'; return; }
        if (!stay) Cart.open();
      });
    },
    change: function (key, qty) {
      var id = Cart.sectionId();
      var body = { id: key, quantity: qty };
      if (id) { body.sections = id; body.sections_url = window.location.pathname; }
      var line = $('[data-p-line="' + key + '"]');
      if (line) line.classList.add('is-loading');
      return postJSON(ROUTES.cartChange ? ROUTES.cartChange + '.js' : '/cart/change.js', body).then(function (data) {
        if (id && data.sections && data.sections[id]) Cart.render(data.sections[id]);
        else Cart.refresh();
      }).catch(function (err) {
        if (line) line.classList.remove('is-loading');
        toast(err.message || TEXT.error);
      });
    }
  };
  window.PahleCart = Cart;

  /* ---------- Gratis-Versand-Codes ----------
     Shopify zieht Versandrabatte erst an der Kasse ab und führt sie im Warenkorb nicht als Rabatt.
     Codes aus „Warenkorb-Drawer > Rabattcodes für Gratis-Versand“ (data-ship-codes am Drawer) merkt sich der
     Warenkorb deshalb im privaten Attribut _pahle_versandcode. Damit zeigen Drawer und Produktseite
     „versandkostenfrei“ und den Code (Snippet pahle-ship-code). Ohne eingetragene Codes passiert hier nichts. */
  var ShipCode = {
    attr: '_pahle_versandcode',
    checked: false,
    busy: false,
    again: false,
    list: function () {
      var el = Cart.el();
      return String((el && el.getAttribute('data-ship-codes')) || '').split(',').map(function (c) { return c.trim().toUpperCase(); }).filter(Boolean);
    },
    on: function () { return ShipCode.list().length > 0; },
    is: function (code) { return ShipCode.list().indexOf(String(code || '').trim().toUpperCase()) !== -1; },
    // Erster Versand-Code aus einer Liste von Codes ('' = keiner)
    pick: function (codes) {
      for (var i = 0; i < codes.length; i++) { if (ShipCode.is(codes[i])) return String(codes[i]).trim().toUpperCase(); }
      return '';
    },
    // Gemerkter Code laut zuletzt geladenem Drawer
    active: function () {
      var inner = $('[data-p-cart] [data-p-cart-inner]');
      return (inner && inner.getAttribute('data-ship-code')) || '';
    },
    text: function (code) {
      var el = Cart.el();
      return String((el && el.getAttribute('data-ship-text')) || 'Gratis-Versand mit Code „[code]“').replace('[code]', code);
    },
    // Abgleich mit Shopify, z. B. wenn der Code über einen Rabatt-Link (/discount/CODE) in den Warenkorb kam.
    // Läuft beim Seitenaufruf und nach Änderungen am Warenkorb, bis einmal ein gefüllter Warenkorb geprüft ist.
    sync: function (tries) {
      if (!ShipCode.on() || ShipCode.checked) return;
      if (ShipCode.busy) { ShipCode.again = true; return; }
      tries = tries || 0;
      // Während die Gratis-Aktion den Warenkorb ändert, kurz warten
      var gift = window.PahleGift;
      if (gift && gift.busy && tries < 6) { setTimeout(function () { ShipCode.sync(tries + 1); }, 700); return; }
      ShipCode.busy = true;
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var want = ShipCode.pick((cart.discount_codes || []).map(function (d) { return d.code; }));
          var have = String((cart.attributes || {})[ShipCode.attr] || '').trim().toUpperCase();
          if (cart.item_count > 0) ShipCode.checked = true;
          if (want === have) return;
          var attrs = {};
          attrs[ShipCode.attr] = want;
          var id = Cart.sectionId();
          var body = { attributes: attrs };
          if (id) { body.sections = id; body.sections_url = window.location.pathname; }
          return postJSON((ROUTES.cartUpdate || '/cart/update') + '.js', body).then(function (data) {
            if (id && data && data.sections && data.sections[id]) Cart.render(data.sections[id]);
          });
        })
        .catch(function () {})
        .then(function () {
          ShipCode.busy = false;
          if (ShipCode.again) { ShipCode.again = false; ShipCode.sync(); }
        });
    }
  };
  window.PahleShipCode = ShipCode;
  document.addEventListener('pahle:cart:updated', function () { if (!ShipCode.checked) setTimeout(ShipCode.sync, 0); });

  /* ---------- Gratis-Aktion: Gratisartikel je Bestellwert automatisch hinzufügen/entfernen ----------
     Einstellungen: Theme-Einstellungen > Pahle Gratis-Aktion. Den Zustand berechnet das Snippet pahle-gift
     bei jeder Aktualisierung des Drawers neu (Soll-/Ist-Menge, Zeitraum, ob Shopify den Artikel kostenlos rechnet).
     Kostenlos macht ihn der automatische Shopify-Rabatt. Rechnet Shopify ihn nicht kostenlos (Rabatt fehlt,
     besserer Rabattcode), wird er wieder entfernt und für diesen Warenkorb-Stand nicht erneut hinzugefügt. */
  var Gift = {
    busy: false,
    own: false,
    chain: 0,
    rechecked: false,
    caps: {},
    state: function () {
      var el = $('[data-p-cart] [data-p-gift-state]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    },
    live: function (s) {
      if (!s || !s.on) return false;
      if (s.test) return true;
      var now = Date.now() / 1000;
      return !(s.start && now < s.start) && !(s.end && now > s.end);
    },
    // Obergrenze für einen Warenkorb-Stand (Variante, Soll-Menge, Rabattcodes), wenn Shopify weniger kostenlos rechnet
    sig: function (s) { return [s.variant, s.want, s.codes].join('|'); },
    cap: function (sig) {
      if (Gift.caps.hasOwnProperty(sig)) return Gift.caps[sig];
      try {
        var stored = JSON.parse(window.sessionStorage.getItem('pahleGiftCap') || 'null');
        if (stored && stored.sig === sig) return stored.cap;
      } catch (e) {}
      return null;
    },
    setCap: function (sig, cap) {
      Gift.caps[sig] = cap;
      try { window.sessionStorage.setItem('pahleGiftCap', JSON.stringify({ sig: sig, cap: cap })); } catch (e) {}
    },
    ui: function (s, live, blocked) {
      $$('[data-p-gift-bar]').forEach(function (bar) {
        bar.hidden = !live || (blocked && !s.codes);
        var warn = $('[data-p-gift-blocked]', bar);
        if (warn) warn.hidden = !blocked;
      });
    },
    sync: function () {
      var own = Gift.own;
      Gift.own = false;
      if (!own) Gift.chain = 0;
      if (Gift.busy) return;
      var s = Gift.state();
      if (!s) return;
      var live = Gift.live(s);
      var sig = Gift.sig(s);
      var cap = live ? Gift.cap(sig) : null;
      var want = live ? s.want : 0;
      if (cap !== null) want = Math.min(want, cap);

      // Sicherheitsnetz: Shopify rechnet die Gratisartikel nicht (alle) kostenlos
      // (Rabatt fehlt, anderer Bestellwert in Shopify, besserer Rabattcode). Erst nach einer zweiten Abfrage.
      if (live && !s.test && s.have > 0 && s.have <= want && !s.free) {
        if (!Gift.rechecked) { Gift.rechecked = true; setTimeout(Cart.refresh, 900); return; }
        cap = Math.max(0, Math.min(s.freeQty || 0, s.have));
        Gift.setCap(sig, cap);
        want = Math.min(want, cap);
      } else if (s.free || !s.have) {
        Gift.rechecked = false;
      }
      Gift.ui(s, live, cap === 0 && s.want > 0);

      var updates = {}, change = false, add = false;
      (s.stale || []).forEach(function (key) { updates[key] = 0; change = true; });
      if (want !== s.have) {
        if (s.lines && s.lines.length) {
          s.lines.forEach(function (l, i) { updates[l.key] = i === 0 ? want : 0; });
          change = true;
        } else if (want > 0 && !change) {
          add = true;
        }
      }
      if (!change && !add) { Gift.chain = 0; return; }
      // Schutz vor Endlosschleifen: höchstens 3 automatische Änderungen hintereinander
      if (own && ++Gift.chain > 3) return;

      Gift.busy = true;
      var id = Cart.sectionId();
      var body = add
        ? { items: [{ id: s.variant, quantity: want, properties: { _pahle_gift: s.label || 'Gratis-Zugabe' } }] }
        : { updates: updates };
      if (id) { body.sections = id; body.sections_url = window.location.pathname; }
      var url = add
        ? (ROUTES.cartAdd ? ROUTES.cartAdd + '.js' : '/cart/add.js')
        : (ROUTES.cartUpdate || '/cart/update') + '.js';
      postJSON(url, body).then(function (data) {
        Gift.busy = false;
        Gift.own = true;
        if (id && data.sections && data.sections[id]) Cart.render(data.sections[id]);
        else Cart.refresh();
        // Warenkorbseite (Expanse-Formular) neu aufbauen, sonst ohne Wirkung
        document.dispatchEvent(new CustomEvent('cart:build'));
      }).catch(function () {
        // z. B. nicht genug Bestand: für diesen Warenkorb-Stand nicht mehr hinzufügen
        Gift.busy = false;
        Gift.setCap(sig, s.have);
        Gift.own = true;
        Cart.refresh();
      });
    }
  };
  window.PahleGift = Gift;
  // Nach jeder Aktualisierung des Drawers abgleichen
  document.addEventListener('pahle:cart:updated', function () { setTimeout(Gift.sync, 0); });
  // Mengenänderung auf der Warenkorbseite (Expanse): Drawer neu laden, danach wird abgeglichen
  document.addEventListener('cart:updated', function () { Cart.refresh(); });

  /* ---------- Rabattcode (Drawer + Warenkorbseite) ---------- */
  var Discount = {
    t: function (key, fallback, code) {
      return (TEXT[key] || fallback).replace('[code]', code || '');
    },
    current: function (box) {
      var list = $$('[data-p-discount-remove]', box).map(function (b) { return b.getAttribute('data-p-discount-remove'); });
      // Gratis-Versand-Code immer mitschicken, damit er beim Einlösen weiterer Codes nicht verloren geht
      var sc = ShipCode.active();
      if (sc && !list.some(function (c) { return c.toUpperCase() === sc; })) list.push(sc);
      return list;
    },
    message: function (box, text) {
      var m = $('[data-p-discount-msg]', box);
      if (!m) { if (text) toast(text); return; }
      m.textContent = text || '';
      m.hidden = !text;
    },
    send: function (codes, inDrawer) {
      var id = inDrawer ? Cart.sectionId() : null;
      var body = { discount: codes.join(',') };
      // Gratis-Versand-Code im Warenkorb merken (bzw. vergessen), damit Drawer und Produktseite ihn zeigen
      if (ShipCode.on()) { body.attributes = {}; body.attributes[ShipCode.attr] = ShipCode.pick(codes); }
      if (id) { body.sections = id; body.sections_url = window.location.pathname; }
      return postJSON((ROUTES.cartUpdate || '/cart/update') + '.js', body);
    },
    done: function (data, inDrawer, note) {
      if (!inDrawer) { window.location.reload(); return; }
      var id = Cart.sectionId();
      if (id && data && data.sections && data.sections[id]) Cart.render(data.sections[id]);
      else Cart.refresh();
      if (note) toast(note);
    },
    apply: function (box) {
      var input = $('[data-p-discount-input]', box);
      var btn = $('[data-p-discount-apply]', box);
      var code = input ? input.value.trim() : '';
      if (!code) { Discount.message(box, Discount.t('discountEmpty', 'Bitte geben Sie einen Rabattcode ein.')); if (input) input.focus(); return; }
      var existing = Discount.current(box);
      var upper = code.toUpperCase();
      code = upper;
      if (existing.some(function (c) { return c.toUpperCase() === upper; })) {
        Discount.message(box, Discount.t('discountDuplicate', 'Der Rabattcode „[code]“ ist bereits eingelöst.', code));
        return;
      }
      var inDrawer = !!box.closest('[data-p-cart]');
      Discount.message(box, '');
      if (btn) btn.classList.add('is-loading');
      // Gratis-Versand-Codes prüft Shopify erst an der Kasse (mit Lieferadresse): nicht als ungültig verwerfen
      var isShip = ShipCode.is(code);
      Discount.send(existing.concat([code]), inDrawer).then(function (data) {
        var rejected = !isShip && (data.discount_codes || []).some(function (d) {
          return String(d.code).toUpperCase() === upper && d.applicable === false;
        });
        if (rejected) {
          // Ungültigen Code wieder entfernen, damit er nicht unsichtbar im Warenkorb bleibt
          return Discount.send(existing, false).catch(function () {}).then(function () {
            if (btn) btn.classList.remove('is-loading');
            var g = Gift.state();
            if (g && Gift.live(g) && g.have > 0 && g.codeText) Discount.message(box, g.codeText.replace('[code]', code));
            else Discount.message(box, Discount.t('discountInvalid', 'Der Rabattcode „[code]“ ist ungültig oder gilt nicht für Ihren aktuellen Warenkorb.', code));
            if (input) input.select();
          });
        }
        Discount.done(data, inDrawer, isShip ? ShipCode.text(code) : Discount.t('discountApplied', 'Rabattcode „[code]“ eingelöst', code));
      }).catch(function (err) {
        if (btn) btn.classList.remove('is-loading');
        Discount.message(box, (err && err.message) || TEXT.error);
      });
    },
    remove: function (box, code, btn) {
      var inDrawer = !!box.closest('[data-p-cart]');
      var keep = Discount.current(box).filter(function (c) { return c.toUpperCase() !== String(code).toUpperCase(); });
      if (btn) btn.disabled = true;
      Discount.send(keep, inDrawer).then(function (data) {
        Discount.done(data, inDrawer, Discount.t('discountRemoved', 'Rabattcode entfernt'));
      }).catch(function (err) {
        if (btn) btn.disabled = false;
        toast((err && err.message) || TEXT.error);
      });
    }
  };

  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest('[data-p-discount-apply]');
    if (applyBtn) { e.preventDefault(); Discount.apply(applyBtn.closest('[data-p-discount]')); return; }
    var removeBtn = e.target.closest('[data-p-discount-remove]');
    if (removeBtn) { e.preventDefault(); Discount.remove(removeBtn.closest('[data-p-discount]'), removeBtn.getAttribute('data-p-discount-remove'), removeBtn); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-p-discount-input]')) return;
    // Enter löst den Code ein und schickt auf der Warenkorbseite nicht versehentlich zur Kasse
    e.preventDefault();
    Discount.apply(e.target.closest('[data-p-discount]'));
  });
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.classList && d.classList.contains('p-disc__toggle') && d.open) {
      var input = $('[data-p-discount-input]', d);
      if (input && isDesktop()) input.focus();
    }
  }, true);

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-p-cart-open]');
    if (openBtn && Cart.el()) { e.preventDefault(); Cart.open(); return; }

    var qtyBtn = e.target.closest('[data-p-qty]');
    if (qtyBtn) { e.preventDefault(); Cart.change(qtyBtn.getAttribute('data-p-qty'), parseInt(qtyBtn.getAttribute('data-qty'), 10)); return; }

    var addBtn = e.target.closest('[data-p-add]');
    if (addBtn) {
      e.preventDefault();
      if (addBtn.classList.contains('is-loading')) return;
      addBtn.classList.add('is-loading');
      var stay = addBtn.hasAttribute('data-p-stay');
      Cart.add([{ id: parseInt(addBtn.getAttribute('data-p-add'), 10), quantity: 1 }], stay)
        .then(function () {
          var card = addBtn.closest('[data-p-card]');
          var quick = card && $('[data-p-quick]', card);
          if (quick) { quick.hidden = true; }
          if (stay) toast(TEXT.added || 'Hinzugefügt');
        })
        .catch(function (err) { toast(err.message || TEXT.error); })
        .then(function () { addBtn.classList.remove('is-loading'); });
    }
  });

  // Gratis-Aktion beim Laden einmal abgleichen (Fehler dort legen den Rest nicht lahm)
  safe(Gift.sync, 'Gratis-Aktion');

  // Expanse-Formulare (andere Produktvorlagen) öffnen ebenfalls den Pahle-Warenkorb
  document.addEventListener('ajaxProduct:added', function () { Cart.refresh().then(Cart.open); });
  document.addEventListener('cart:refresh', function () { Cart.refresh(); });

  /* ---------- Produktkarten: Variantenauswahl ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-p-quick-toggle]');
    if (toggle) {
      e.preventDefault();
      var card = toggle.closest('[data-p-card]');
      var panel = card && $('[data-p-quick]', card);
      if (panel) { panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); var first = $('button[data-p-add]', panel); if (first) first.focus(); }
      return;
    }
    var close = e.target.closest('[data-p-quick-close]');
    if (close) {
      var c = close.closest('[data-p-card]');
      var p = c && $('[data-p-quick]', c);
      if (p) p.hidden = true;
      var t = c && $('[data-p-quick-toggle]', c);
      if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
    }
  });

  /* ---------- Header: Mega-Menü ---------- */
  var backdrop;
  function ensureBackdrop() {
    if (!backdrop) { backdrop = document.createElement('div'); backdrop.className = 'p-header__backdrop'; document.body.appendChild(backdrop); backdrop.addEventListener('mouseenter', closeMegas); backdrop.addEventListener('click', closeMegas); }
    return backdrop;
  }
  function openMega(item) {
    $$('[data-p-nav-item].is-open').forEach(function (i) { if (i !== item) { i.classList.remove('is-open'); var l = $('.p-nav__link', i); if (l) l.setAttribute('aria-expanded', 'false'); } });
    loadDeferred(item);
    item.classList.add('is-open');
    var link = $('.p-nav__link', item); if (link) link.setAttribute('aria-expanded', 'true');
    if ($('.p-mega', item)) ensureBackdrop().classList.add('is-visible');
    else if (backdrop) backdrop.classList.remove('is-visible');
  }
  function closeMegas() {
    $$('[data-p-nav-item].is-open').forEach(function (i) { i.classList.remove('is-open'); var l = $('.p-nav__link', i); if (l) l.setAttribute('aria-expanded', 'false'); });
    if (backdrop) backdrop.classList.remove('is-visible');
  }
  function initNav() {
    var nav = $('.p-nav');
    if (nav) nav.addEventListener('mouseenter', function () { loadDeferred(nav); }, { once: true });
    $$('[data-p-nav-item]').forEach(function (item) {
      var timer;
      item.addEventListener('mouseenter', function () { if (!isDesktop()) return; clearTimeout(timer); timer = setTimeout(function () { openMega(item); }, 80); });
      item.addEventListener('mouseleave', function () { clearTimeout(timer); timer = setTimeout(function () { if (!item.matches(':hover')) { item.classList.remove('is-open'); if (!$('[data-p-nav-item].is-open') && backdrop) backdrop.classList.remove('is-visible'); } }, 150); });
      var link = $('.p-nav__link', item);
      if (link) {
        link.addEventListener('click', function (e) {
          // Touch-Geräte: erster Tipp öffnet das Menü, zweiter folgt dem Link
          if (window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) { e.preventDefault(); openMega(item); }
        });
        link.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); openMega(item); var first = $('.p-mega a, .p-dropdown a', item); if (first) first.focus(); }
        });
      }
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) { item.classList.remove('is-open'); if (!$('[data-p-nav-item].is-open') && backdrop) backdrop.classList.remove('is-visible'); } });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-p-nav-item]')) closeMegas(); });
  }

  /* ---------- Header: Suche mit Vorschlägen ---------- */
  function initSearch() {
    var form = $('[data-p-search]');
    if (!form) return;
    var input = $('[data-p-search-input]', form);
    var box = $('[data-p-search-results]', form);
    var toggle = $('[data-p-search-toggle]');
    var timer, lastQ = '';
    if (toggle) toggle.addEventListener('click', function () { form.classList.toggle('is-open'); if (form.classList.contains('is-open')) input.focus(); });
    if (!input || !box || !ROUTES.predictiveSearch) return;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { box.hidden = true; return; }
      timer = setTimeout(function () {
        lastQ = q;
        var url = ROUTES.predictiveSearch + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url).then(function (r) { return r.json(); }).then(function (data) {
          if (q !== lastQ) return;
          var res = (data && data.resources && data.resources.results) || {};
          var html = '';
          (res.products || []).forEach(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
            html += '<a class="p-sres" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<img alt="">') +
              '<span><span class="p-sres__t">' + escapeHtml(p.title) + '</span><br><span class="p-sres__p">' + (p.price ? (p.price_min !== p.price_max ? 'ab ' : '') + formatMoney(Math.round(parseFloat(p.price_min || p.price) * 100)) : '') + '</span></span></a>';
          });
          var others = (res.collections || []).concat(res.pages || []);
          if (others.length) {
            html += '<span class="p-sres__label">Seiten und Kategorien</span>';
            others.forEach(function (c) { html += '<a class="p-sres" href="' + c.url + '"><span class="p-sres__t">' + escapeHtml(c.title) + '</span></a>'; });
          }
          html += '<a class="p-sres__all" href="' + (ROUTES.search || '/search') + '?q=' + encodeURIComponent(q) + '">Alle Ergebnisse für „' + escapeHtml(q) + '“</a>';
          box.innerHTML = html;
          box.hidden = false;
        }).catch(function () { box.hidden = true; });
      }, 220);
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) box.hidden = true; });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { box.hidden = true; } });
  }
  function escapeHtml(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Ankündigungsleiste (mobil wechselnd) ---------- */
  function initAnnouncement() {
    $$('[data-p-announce]').forEach(function (bar) {
      var items = $$('.p-announce__item', bar);
      if (items.length < 2) return;
      var i = 0;
      setInterval(function () {
        if (isDesktop()) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4000);
    });
  }

  /* ---------- Reiter (Bestseller) ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-p-tab]');
    if (!tab) return;
    var list = tab.parentElement;
    var tabs = $$('[data-p-tab]', list);
    tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); var panel = document.getElementById(t.getAttribute('aria-controls')); if (panel) panel.hidden = !on; });
  });

  /* ---------- Slider (Kundenstimmen) ---------- */
  function initSliders() {
    $$('[data-p-slider]').forEach(function (s) {
      var track = $('[data-p-track]', s);
      if (!track) return;
      var dots = $('[data-p-dots]', s);
      var slides = track.children;
      function step() { return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth; }
      $$('[data-p-slide]', s).forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step() * parseInt(b.getAttribute('data-p-slide'), 10), behavior: 'smooth' }); }); });
      if (dots && slides.length > 1) {
        dots.innerHTML = Array.prototype.map.call(slides, function (_, i) { return '<span' + (i === 0 ? ' class="is-active"' : '') + '></span>'; }).join('');
        track.addEventListener('scroll', function () {
          var idx = Math.round(track.scrollLeft / step());
          $$('span', dots).forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }, { passive: true });
      }
    });
  }

  /* ---------- Akkordeons: nur eines offen ---------- */
  function initAccordions() {
    $$('[data-p-accordion]').forEach(function (acc) {
      $$('details', acc).forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          $$('details', acc).forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* ---------- Footer: mobil zugeklappt ---------- */
  function initFooter() {
    if (isDesktop()) return;
    $$('[data-p-footer-col]').forEach(function (d) { d.open = false; });
  }

  /* ---------- Wunschliefertermin (Zeitzone Berlin) ---------- */
  var DD = CFG.delivery || {};
  function pad(n) { return ('0' + n).slice(-2); }
  function parseDays(str) { return String(str || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(function (x) { return x >= 1 && x <= 6; }); }
  // "Wanduhr" Berlin als UTC-Datum, damit Rechnen mit Tagen zeitzonensicher ist
  function berlinNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
      .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour % 24, +parts.minute, +parts.second));
  }
  function utcDate(y, m, d) { return new Date(Date.UTC(y, m, d)); }
  function isoDow(d) { var x = d.getUTCDay(); return x === 0 ? 7 : x; }
  function isoKey(d) { return d.toISOString().slice(0, 10); }
  function dayOnly(d) { return utcDate(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()); }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
  function addMonths(d, n) {
    var y = d.getUTCFullYear(), m = d.getUTCMonth() + n;
    var last = utcDate(y, m + 1, 0).getUTCDate();
    return utcDate(y, m, Math.min(d.getUTCDate(), last));
  }
  function monthStart(d) { return utcDate(d.getUTCFullYear(), d.getUTCMonth(), 1); }
  function fmtAttr(d) { return pad(d.getUTCDate()) + '.' + pad(d.getUTCMonth() + 1) + '.' + d.getUTCFullYear(); }
  function parseAttr(v) { var m = String(v || '').match(/^(\d{2})\.(\d{2})\.(\d{4})$/); return m ? utcDate(+m[3], +m[2] - 1, +m[1]) : null; }
  var WD_SHORT = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  var WD_LONG = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

  // Ostersonntag (gregorianischer Kalender)
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var n = h + l - 7 * m + 114;
    return utcDate(y, Math.floor(n / 31) - 1, (n % 31) + 1);
  }
  // Bundesweite Feiertage: Neujahr, Karfreitag, Ostermontag, 1. Mai, Himmelfahrt, Pfingstmontag, 3. Oktober, 1./2. Weihnachtstag
  function holidaySet(years) {
    var set = {};
    years.forEach(function (y) {
      ['01-01', '05-01', '10-03', '12-25', '12-26'].forEach(function (md) { set[y + '-' + md] = true; });
      var e = easter(y);
      [-2, 1, 39, 50].forEach(function (n) { set[isoKey(addDays(e, n))] = true; });
    });
    return set;
  }
  // Gesperrte Tage aus den Theme-Einstellungen: "24.12." (jährlich), "04.06.2027" (einmalig), "27.12.2026 - 02.01.2027" (Zeitraum)
  function blockedRules(text) {
    var out = { dates: {}, yearly: {}, ranges: [] };
    function toDate(d, m, y) { y = +y; if (y < 100) y += 2000; return utcDate(y, +m - 1, +d); }
    String(text || '').split(/\r?\n|;|,/).forEach(function (raw) {
      var line = raw.trim(), m;
      if (!line) return;
      if ((m = line.match(/^(\d{1,2})\.(\d{1,2})\.(\d{2}|\d{4})\s*(?:-|–|bis)\s*(\d{1,2})\.(\d{1,2})\.(\d{2}|\d{4})$/))) {
        out.ranges.push([toDate(m[1], m[2], m[3]), toDate(m[4], m[5], m[6])]);
      } else if ((m = line.match(/^(\d{1,2})\.(\d{1,2})\.(\d{2}|\d{4})$/))) {
        out.dates[isoKey(toDate(m[1], m[2], m[3]))] = true;
      } else if ((m = line.match(/^(\d{1,2})\.(\d{1,2})\.?$/))) {
        out.yearly[pad(m[2]) + '-' + pad(m[1])] = true;
      }
    });
    return out;
  }

  var Delivery = {
    rules: function () {
      var now = berlinNow();
      var today = dayOnly(now);
      var cutoff = new Date(today.getTime());
      cutoff.setUTCHours(DD.cutoffHour == null ? 11 : DD.cutoffHour, DD.cutoffMinute || 0, 0, 0);
      var y = today.getUTCFullYear();
      return {
        now: now, today: today, afterCutoff: now >= cutoff,
        deliver: parseDays(DD.deliveryDays == null ? '2,3,4,5' : DD.deliveryDays),
        transit: Math.max(1, DD.transitDays || 1),
        last: addMonths(today, DD.horizonMonths || 6),
        blocked: blockedRules(DD.blockedDates),
        holidays: DD.holidays === false ? {} : holidaySet([y, y + 1, y + 2])
      };
    },
    isBlocked: function (r, d) {
      var k = isoKey(d);
      if (r.holidays[k] || r.blocked.dates[k] || r.blocked.yearly[k.slice(5)]) return true;
      return r.blocked.ranges.some(function (x) { return d >= x[0] && d <= x[1]; });
    },
    canShip: function (r, d) {
      if (d < r.today) return false;
      if (+d === +r.today && r.afterCutoff) return false;
      var dow = isoDow(d);
      return dow <= 5 && !Delivery.isBlocked(r, d);
    },
    isValid: function (r, d) {
      if (!d || isNaN(d) || isoDow(d) === 7 || r.deliver.indexOf(isoDow(d)) < 0) return false;
      if (d > r.last || Delivery.isBlocked(r, d)) return false;
      return Delivery.canShip(r, addDays(d, -r.transit));
    },
    dates: function (r, count) {
      var out = [];
      for (var d = addDays(r.today, r.transit); d <= r.last && out.length < count; d = addDays(d, 1)) {
        if (Delivery.isValid(r, d)) out.push(d);
      }
      return out;
    }
  };
  window.PahleDelivery = Delivery;

  /* ---------- Lieferdatum-Hinweis (Produktseite): „Bis [frist] bestellt – am [liefertag] bei Ihnen“ ----------
     Rechnet mit denselben Regeln wie die Datumsauswahl im Warenkorb (Theme-Einstellungen > Pahle Design).
     Markup: snippets/pahle-delivery-note.liquid. Der Text mit den Platzhaltern kommt aus dem Theme-Editor.
     Platzhalter: [frist] = Bestellschluss für den frühesten Termin, [liefertag], [wochentag], [datum] = frühester Liefertag. */
  function initDeliveryNotes(root) {
    var notes = $$('[data-p-delivery-note]', root || document).filter(function (el) { return !el._pInit; });
    if (!notes.length) return;
    var r = Delivery.rules();
    var first = Delivery.dates(r, 1)[0];
    if (!first) return;
    var ship = addDays(first, -r.transit);
    var gap = Math.round((ship - r.today) / 86400000);
    var minute = DD.cutoffMinute || 0;
    var time = (DD.cutoffHour == null ? 11 : DD.cutoffHour) + (minute ? ':' + pad(minute) : '') + ' Uhr';
    var day = gap === 0 ? 'heute' : gap === 1 ? 'morgen' : WD_LONG[ship.getUTCDay()];
    if (gap > 6) day += ', ' + ship.getUTCDate() + '. ' + MONTHS[ship.getUTCMonth()] + ',';
    var values = {
      frist: day + ' ' + time,
      liefertag: WD_LONG[first.getUTCDay()] + ', ' + first.getUTCDate() + '. ' + MONTHS[first.getUTCMonth()],
      wochentag: WD_LONG[first.getUTCDay()],
      datum: pad(first.getUTCDate()) + '.' + pad(first.getUTCMonth() + 1) + '.'
    };
    notes.forEach(function (el) {
      el._pInit = true;
      var text = $('[data-p-delivery-text]', el);
      if (!text) return;
      text.innerHTML = text.innerHTML.replace(/\[(frist|liefertag|wochentag|datum)\]/gi, function (m, key) { return values[key.toLowerCase()]; });
      el.hidden = false;
    });
  }

  var ddSaving = null;
  var ddLast = null; // zuletzt gewählter Termin (schützt vor veralteten Werten beim Neuaufbau des Drawers)
  function saveDeliveryAttr(key, value) {
    var attrs = {}; attrs[key] = value;
    ddSaving = postJSON((ROUTES.cartUpdate || '/cart/update') + '.js', { attributes: attrs })
      .catch(function () { toast(TEXT.error); })
      .then(function () { ddSaving = null; });
    return ddSaving;
  }

  function initDeliveryPicker(el) {
    if (!el || el._pInit) return;
    el._pInit = true;
    var key = el.getAttribute('data-key') || 'Wunschliefertermin';
    var stored = ddLast || el.getAttribute('data-value') || '';
    var summaryRows = $$('[data-p-dd-summary-row]');
    function setSummary(d) {
      summaryRows.forEach(function (row) {
        row.hidden = !d;
        var dd = $('[data-p-dd-summary]', row);
        if (dd && d) dd.textContent = WD_SHORT[d.getUTCDay()] + ' ' + pad(d.getUTCDate()) + '.' + pad(d.getUTCMonth() + 1) + '.';
      });
    }
    if (el.hasAttribute('data-disabled')) {
      if (stored) saveDeliveryAttr(key, '');
      setSummary(null);
      return;
    }
    var r = Delivery.rules();
    var daysBox = $('[data-p-dd-days]', el);
    var toggle = $('[data-p-dd-toggle]', el);
    var toggleLabel = $('[data-p-dd-more-label]', el);
    var cal = $('[data-p-dd-cal]', el);
    var msg = $('[data-p-dd-msg]', el);
    var quick = Delivery.dates(r, 4);
    var selected = parseAttr(stored);
    var minMonth = monthStart(quick[0] || r.today);
    var maxMonth = monthStart(r.last);
    var calMonth = minMonth;
    function showMsg(text) { if (msg) { msg.textContent = text || ''; msg.hidden = !text; } }
    function inQuick(d) { return !!d && quick.some(function (q) { return +q === +d; }); }
    function renderCal() {
      if (!cal) return;
      var y = calMonth.getUTCFullYear(), m = calMonth.getUTCMonth();
      var html = '<div class="p-dd__cal-head">' +
        '<button type="button" class="p-dd__nav" data-p-dd-nav="-1" aria-label="Vorheriger Monat"' + (+calMonth <= +minMonth ? ' disabled' : '') + '>‹</button>' +
        '<strong>' + MONTHS[m] + ' ' + y + '</strong>' +
        '<button type="button" class="p-dd__nav" data-p-dd-nav="1" aria-label="Nächster Monat"' + (+calMonth >= +maxMonth ? ' disabled' : '') + '>›</button></div>' +
        '<div class="p-dd__grid">' + ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'].map(function (w) { return '<span class="p-dd__wd">' + w + '</span>'; }).join('');
      for (var i = 1; i < isoDow(calMonth); i++) html += '<span></span>';
      var days = utcDate(y, m + 1, 0).getUTCDate();
      for (var dnum = 1; dnum <= days; dnum++) {
        var d = utcDate(y, m, dnum);
        var ok = Delivery.isValid(r, d);
        var on = selected && +selected === +d;
        html += '<button type="button" class="p-dd__cell' + (on ? ' is-selected' : '') + '"' +
          (ok ? ' data-date="' + fmtAttr(d) + '"' : ' disabled') +
          ' aria-label="' + WD_SHORT[d.getUTCDay()] + ' ' + fmtAttr(d) + (ok ? '' : ' – nicht wählbar') + '"' + (on ? ' aria-pressed="true"' : '') + '>' + dnum + '</button>';
      }
      cal.innerHTML = html + '</div>';
    }
    function render() {
      daysBox.innerHTML = quick.map(function (d) {
        var on = selected && +selected === +d;
        return '<button type="button" class="p-dd__day' + (on ? ' is-selected' : '') + '" role="radio" aria-checked="' + on + '" data-date="' + fmtAttr(d) + '">' +
          '<strong>' + WD_SHORT[d.getUTCDay()] + '</strong><span>' + pad(d.getUTCDate()) + '.' + pad(d.getUTCMonth() + 1) + '.</span></button>';
      }).join('');
      var later = selected && !inQuick(selected);
      if (toggle) toggle.classList.toggle('is-selected', !!later);
      if (toggleLabel) toggleLabel.textContent = later ? (TEXT.ddChosen || 'Ihr Termin:') + ' ' + WD_SHORT[selected.getUTCDay()] + ' ' + fmtAttr(selected) : (TEXT.ddMore || 'Späteres Datum wählen');
      if (cal && !cal.hidden) renderCal();
      el.classList.toggle('has-date', !!selected);
      setSummary(selected);
    }
    function openCal(open) {
      if (!cal || !toggle) return;
      cal.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var base = selected && !inQuick(selected) ? selected : (quick.length ? addDays(quick[quick.length - 1], 1) : r.today);
        calMonth = monthStart(base);
        if (+calMonth < +minMonth) calMonth = minMonth;
        if (+calMonth > +maxMonth) calMonth = maxMonth;
        renderCal();
      }
    }
    function choose(d, silent) {
      selected = d;
      ddLast = fmtAttr(d);
      el.setAttribute('data-value', fmtAttr(d));
      if (!silent) showMsg('');
      render();
      saveDeliveryAttr(key, fmtAttr(d));
    }
    if (selected && !Delivery.isValid(r, selected)) {
      selected = null;
      if (quick.length) { choose(quick[0], true); showMsg(TEXT.ddExpired); }
      else render();
    } else if (!selected && DD.preselect && quick.length) {
      choose(quick[0], true);
    } else {
      render();
    }
    el._pChoose = function (d) {
      r = Delivery.rules();
      if (Delivery.isValid(r, d)) { choose(d); return true; }
      showMsg(TEXT.ddInvalid); render(); return false;
    };
    // Klick-Logik über das Element, damit ein Neuaufbau (Checkout-Prüfung) immer den aktuellen Zustand nutzt
    el._pClick = function (e) {
      var nav = e.target.closest('[data-p-dd-nav]');
      if (nav) { calMonth = addMonths(calMonth, +nav.getAttribute('data-p-dd-nav')); renderCal(); return; }
      if (e.target.closest('[data-p-dd-toggle]')) { openCal(cal.hidden); return; }
      var b = e.target.closest('[data-date]');
      if (b) {
        var fromCal = cal && cal.contains(b);
        if (el._pChoose(parseAttr(b.getAttribute('data-date'))) && fromCal) openCal(false);
      }
    };
    if (el._pBound) return;
    el._pBound = true;
    el.addEventListener('click', function (e) { el._pClick(e); });
  }
  function initDeliveryPickers(root) { $$('[data-p-dd]', root).forEach(initDeliveryPicker); }

  // Vor dem Checkout: Speichern abwarten und Termin prüfen
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var sub = e.submitter;
    var isCheckout = (sub && sub.name === 'checkout') || $('[name="checkout"]', form);
    if (!isCheckout) return;
    var picker = $('[data-p-dd]:not([data-disabled])') ;
    if (picker) {
      var chosen = parseAttr(picker.getAttribute('data-value'));
      // Seite lange offen (z. B. über den Bestellschluss hinaus): Termin erneut prüfen
      var problem = !chosen ? TEXT.ddRequired : (!Delivery.isValid(Delivery.rules(), chosen) ? TEXT.ddExpired : '');
      if (problem) {
        e.preventDefault();
        if (chosen) { picker._pInit = false; picker.removeAttribute('data-value'); ddLast = null; initDeliveryPicker(picker); }
        var m = $('[data-p-dd-msg]', picker); if (m) { m.textContent = problem; m.hidden = false; }
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }
    if (ddSaving) {
      e.preventDefault();
      ddSaving.then(function () {
        var input = document.createElement('input'); input.type = 'hidden'; input.name = 'checkout'; input.value = '';
        form.appendChild(input); form.submit();
      });
    }
  }, true);

  /* ---------- Produktseite ---------- */
  function initPDP(pdp) {
    var jsonEl = $('[data-p-product-json]', pdp);
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var form = $('[data-p-product-form]', pdp) || $('form[action*="/cart/add"]', pdp);
    var idInput = $('[data-p-variant-input]', pdp);
    var qtyInput = $('[data-p-qty-input]', pdp);
    var priceEl = $('[data-p-price]', pdp), compareEl = $('[data-p-compare]', pdp), unitEl = $('[data-p-unit]', pdp);
    var atcBtn = $('[data-p-atc]', pdp), stickyBtn = $('[data-p-sticky-atc]', pdp);
    var errorEl = $('[data-p-form-error]', pdp);
    var cartTotal = parseInt(pdp.getAttribute('data-cart-total') || '0', 10);
    var threshold = CFG.freeShipping || 0;
    var current = variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || variants[0];
    var selected = current ? current.options.slice() : [];

    function findVariant(opts) {
      return variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
    }
    function addonTotal() {
      return $$('[data-p-addon]', pdp).reduce(function (sum, cb) { return sum + (cb.checked ? parseInt(cb.getAttribute('data-price'), 10) : 0); }, 0);
    }
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }

    function updateProgress() {
      var box = $('[data-p-pdp-progress]', pdp);
      if (!box || !threshold || !current) return;
      var sc = ShipCode.active();
      if (sc) {
        $('[data-p-progress-text]', box).textContent = ShipCode.text(sc);
        $('[data-p-progress-bar]', box).style.width = '100%';
        return;
      }
      var total = cartTotal + current.price * qty() + addonTotal();
      var rest = threshold - total;
      $('[data-p-progress-text]', box).textContent = rest > 0 ? (TEXT.freeShippingLeft || '').replace('[amount]', formatMoney(rest)) : TEXT.freeShippingReached;
      $('[data-p-progress-bar]', box).style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
    }

    function updateButtons() {
      var label;
      if (!current) label = TEXT.unavailable;
      else if (!current.available) label = TEXT.soldOut;
      else label = (TEXT.addToCart || 'In den Warenkorb') + ' – ' + formatMoney(current.price * qty() + addonTotal());
      $$('[data-p-atc-label]', pdp).forEach(function (l) { l.textContent = label; });
      var disabled = !current || !current.available;
      if (atcBtn) atcBtn.disabled = disabled;
      if (stickyBtn) stickyBtn.disabled = disabled;
      var sq = $('[data-p-sticky-qty]', pdp); if (sq) sq.textContent = qty();
      updateProgress();
    }

    // Mengen-Kacheln hängen von der gewählten Verarbeitung ab (nicht vorhandene Kombinationen
    // werden ausgeblendet). Alle anderen Optionen sind unabhängig: durchgestrichen nur, wenn es
    // für diesen Wert überhaupt keine verfügbare Variante gibt.
    function updateOptions() {
      $$('[data-p-option]', pdp).forEach(function (fs) {
        var oi = parseInt(fs.getAttribute('data-p-option'), 10);
        var dependent = oi === data.sizeIndex;
        $$('[data-p-value]', fs).forEach(function (btn) {
          var val = btn.getAttribute('data-p-value');
          var on = selected[oi] === val;
          btn.classList.toggle('is-selected', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (dependent) {
            var test = selected.slice(); test[oi] = val;
            var v = findVariant(test);
            btn.hidden = !v;
            btn.classList.toggle('is-soldout', !!v && !v.available);
            var priceSpan = $('[data-p-tile-price]', btn);
            if (priceSpan && v) priceSpan.textContent = formatMoney(v.price);
          } else {
            var anyAvailable = variants.some(function (x) { return x.options[oi] === val && x.available; });
            btn.classList.toggle('is-soldout', !anyAvailable);
          }
        });
      });
    }

    // Beste Variante für einen neu gewählten Wert: exakte Kombination, sonst die verfügbare
    // Variante mit diesem Wert, deren Preis dem bisherigen am nächsten liegt.
    function pickVariant(oi, val, prevPrice) {
      var exact = selected.slice(); exact[oi] = val;
      var hit = findVariant(exact);
      if (hit && hit.available) return hit;
      var pool = variants.filter(function (v) { return v.options[oi] === val && v.available; });
      if (!pool.length) pool = variants.filter(function (v) { return v.options[oi] === val; });
      if (!pool.length) return hit;
      pool.sort(function (a, b) {
        var d = Math.abs(a.price - prevPrice) - Math.abs(b.price - prevPrice);
        if (d !== 0) return d;
        var ma = a.options.filter(function (o, i) { return o === selected[i]; }).length;
        var mb = b.options.filter(function (o, i) { return o === selected[i]; }).length;
        return mb - ma;
      });
      return pool[0];
    }

    function updateVariant(scrollMedia) {
      current = findVariant(selected);
      if (current) {
        if (idInput) idInput.value = current.id;
        if (priceEl) priceEl.textContent = formatMoney(current.price);
        if (compareEl) { compareEl.hidden = !(current.compare > current.price); compareEl.textContent = formatMoney(current.compare); }
        if (unitEl) unitEl.textContent = current.unit || '';
        var stockTitle = $('[data-p-stock-title]', pdp);
        if (stockTitle) stockTitle.textContent = current.available ? stockTitle.getAttribute('data-default') : (stockTitle.getAttribute('data-soldout') || TEXT.soldOut);
        $$('[data-p-stock-text]', pdp).forEach(function (el) { el.hidden = !current.available; });
        var stockBox = $('[data-p-stock]', pdp); if (stockBox) stockBox.classList.toggle('is-soldout', !current.available);
        $$('[data-p-delivery-note]', pdp).forEach(function (el) { el.classList.toggle('is-off', !current.available); });
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', current.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (scrollMedia && current.media) gallery.goToMedia(current.media);
      }
      updateOptions();
      updateButtons();
    }

    $$('[data-p-option]', pdp).forEach(function (fs) {
      var oi = parseInt(fs.getAttribute('data-p-option'), 10);
      fs.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-p-value]');
        if (!btn) return;
        var val = btn.getAttribute('data-p-value');
        var prevPrice = current ? current.price : 0;
        var next = pickVariant(oi, val, prevPrice);
        if (next) selected = next.options.slice(); else selected[oi] = val;
        updateVariant(true);
      });
    });

    $$('[data-p-qty-step]', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        qtyInput.value = Math.max(1, qty() + parseInt(b.getAttribute('data-p-qty-step'), 10));
        updateButtons();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', updateButtons);
    $$('[data-p-addon]', pdp).forEach(function (cb) { cb.addEventListener('change', updateButtons); });
    document.addEventListener('pahle:cart:updated', function (e) { if (e.detail && typeof e.detail.total === 'number') { cartTotal = e.detail.total; updateProgress(); } });

    function submit(e) {
      if (e) e.preventDefault();
      if (!current || !current.available) return;
      var items = [{ id: current.id, quantity: qty() }];
      $$('[data-p-addon]', pdp).forEach(function (cb) { if (cb.checked) items.push({ id: parseInt(cb.value, 10), quantity: 1 }); });
      [atcBtn, stickyBtn].forEach(function (b) { if (b) b.classList.add('is-loading'); });
      if (errorEl) errorEl.hidden = true;
      Cart.add(items).then(function () {
        $$('[data-p-addon]', pdp).forEach(function (cb) { cb.checked = false; });
        updateButtons();
      }).catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message || TEXT.error; errorEl.hidden = false; }
        else toast(err.message || TEXT.error);
      }).then(function () {
        [atcBtn, stickyBtn].forEach(function (b) { if (b) b.classList.remove('is-loading'); });
      });
    }
    if (form) form.addEventListener('submit', submit);
    if (stickyBtn) stickyBtn.addEventListener('click', submit);

    // Galerie
    var gallery = (function () {
      var g = $('[data-p-gallery]', pdp);
      var track = g && $('[data-p-gallery-track]', g);
      if (!track) return { goToMedia: function () {} };
      var slides = $$('.p-gallery__slide', track);
      var thumbs = $$('[data-p-gallery-thumb]', g);
      var counter = $('[data-p-gallery-counter]', g);
      function go(i) { i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); }
      function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      track.addEventListener('scroll', function () {
        var i = index();
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      }, { passive: true });
      $$('[data-p-gallery-step]', g).forEach(function (b) { b.addEventListener('click', function () { go(index() + parseInt(b.getAttribute('data-p-gallery-step'), 10)); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-p-gallery-thumb'), 10)); }); });
      return {
        goToMedia: function (mediaId) {
          slides.forEach(function (s, i) { if (s.getAttribute('data-media-id') === String(mediaId)) go(i); });
        }
      };
    })();


    // Sticky-Kaufleiste (mobil)
    var sticky = $('[data-p-sticky-buy]', pdp);
    var buy = $('[data-p-buy]', pdp);
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', sticky).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      }).observe(buy);
    }

    updateVariant(false);
  }

  /* ---------- Produktempfehlungen nachladen ---------- */
  function initRecommendations() {
    $$('[data-p-reco]').forEach(function (sec) {
      fetch(sec.getAttribute('data-p-reco')).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-p-reco-target]', doc);
        var target = $('[data-p-reco-target]', sec);
        if (fresh && target && fresh.children.length) target.innerHTML = fresh.innerHTML;
        else if (target && !target.children.length) sec.hidden = true;
      }).catch(function () {});
    });
  }

  /* ---------- Exit-Intent ---------- */
  var Exit = (function () {
    var el, shown = false, storeKey = 'pahle-exit-seen';
    function seenRecently(days) {
      try { var t = parseInt(localStorage.getItem(storeKey) || '0', 10); return t && (Date.now() - t) < days * 86400000; } catch (e) { return false; }
    }
    function remember() { try { localStorage.setItem(storeKey, String(Date.now())); } catch (e) {} }
    function open(force) {
      if (!el || (shown && !force)) return;
      if ($('.p-drawer.is-open')) return;
      shown = true; remember();
      loadDeferred(el);
      el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('p-lock');
      var panel = $('.p-modal__panel', el); if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
    }
    function close() {
      if (!el || !el.classList.contains('is-open')) return;
      el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
      if (!$('.p-drawer.is-open')) document.documentElement.classList.remove('p-lock');
    }
    function init() {
      el = $('[data-p-exit]');
      if (!el) return;
      el.addEventListener('click', function (e) { if (e.target.closest('[data-p-exit-close]')) { e.preventDefault(); close(); } });
      if ($('[data-p-exit-success]', el)) { open(true); return; }
      if (window.Shopify && window.Shopify.designMode) return;
      if (el.getAttribute('data-skip-customers') === 'true' && el.hasAttribute('data-customer')) return;
      var days = parseInt(el.getAttribute('data-days') || '14', 10);
      if (seenRecently(days)) return;
      if (/\/(cart|checkout|account)/.test(window.location.pathname)) return;
      var start = Date.now();
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0 && Date.now() - start > 5000 && isDesktop()) open();
      });
      var delay = parseInt(el.getAttribute('data-mobile-delay') || '0', 10);
      if (delay > 0) {
        var lastY = window.scrollY, ready = false;
        setTimeout(function () { ready = true; }, delay * 1000);
        window.addEventListener('scroll', function () {
          var y = window.scrollY;
          if (ready && !isDesktop() && lastY - y > 120 && y > 400) open();
          lastY = y;
        }, { passive: true });
      }
    }
    return { init: init, open: open, close: close };
  })();

  /* ---------- Theme-Editor ---------- */
  document.addEventListener('shopify:section:select', function (e) {
    var t = e.target;
    if ($('[data-p-cart]', t)) Cart.open();
    if ($('[data-p-exit]', t)) Exit.open(true);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var t = e.target;
    if ($('[data-p-cart]', t)) closeDrawer($('[data-p-cart]', t));
    if ($('[data-p-exit]', t)) Exit.close();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest && e.target.closest('[data-p-nav-item]');
    if (item) openMega(item);
  });
  document.addEventListener('shopify:section:load', function (e) {
    initNav(); initSearch(); initSliders(); initAccordions(); initRecommendations();
    $$('[data-p-pdp]', e.target).forEach(initPDP);
    initDeliveryNotes(e.target);
    if ($('[data-p-exit]', e.target)) Exit.init();
  });

  /* ---------- Start ---------- */
  // Jeder Baustein startet für sich: Ein Fehler in einem Teil legt die anderen (z. B. Menü, Warenkorb) nicht lahm
  function safe(fn, name) {
    try { fn(); } catch (err) { if (window.console) console.error('[Pahle] ' + name, err); }
  }
  function init() {
    safe(initNav, 'Menü');
    safe(initSearch, 'Suche');
    safe(initAnnouncement, 'Ankündigung');
    safe(initSliders, 'Slider');
    safe(initAccordions, 'Akkordeons');
    safe(initFooter, 'Footer');
    safe(initRecommendations, 'Empfehlungen');
    $$('[data-p-pdp]').forEach(function (el) { safe(function () { initPDP(el); }, 'Produktseite'); });
    safe(function () { initDeliveryPickers(document); }, 'Wunschliefertermin');
    safe(function () { initDeliveryNotes(document); }, 'Lieferdatum');
    safe(function () { Exit.init(); }, 'Exit-Intent');
    safe(function () { ShipCode.sync(); }, 'Versand-Code');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
